module.exports = __webpack_public_path__ + "img/icon-53.0655c0c8.png";